import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { ItemCategoryService, ItemService, StoreResponseDto } from 'src/generated_client';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.css']
})
export class AddProductComponent implements OnInit {

  store: StoreResponseDto = {};
  allCategories: CategoryOption[] = [];

  addProductForm: FormGroup = this.fb.group({
    cdStore: [],
    categoria: ['', Validators.required],
    nombre: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, WhiteSpaceValidator.cannontStartWithSpace])],
    descripcion: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, WhiteSpaceValidator.cannontStartWithSpace])],
    estado: ['', Validators.required],
    imagen: [, Validators.required],
    orden: ['', Validators.required],
    textP: [],
    textM: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace, WhiteSpaceValidator.cannontStartWithSpace])],
    textG: [],
    precioP: [],
    precioM: ['', Validators.compose([Validators.required, Validators.min(1)])],
    precioG: [],
    banner: [false, Validators.required]
  })

  status = [
    { value: true, viewValue: 'Activo' },
    { value: false, viewValue: 'Desactivado' },
  ];

  constructor(
    public itemService: ItemService,
    public authService: AuthService,
    public itemCategoryService: ItemCategoryService,
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private router: Router
  ) { }

  ngOnInit() {
    this.store = this.authService.currentUserStore();
    this.addProductForm.controls['cdStore'].setValue(Number(this.store.cdStore));
    this.itemCategoryService.apiItemCategoryGetAllGet(Number(this.store.cdStore)).subscribe(categories => {
      categories.forEach(c => {
        let category: CategoryOption;
        category = {
          id: Number(c.cdItemsCategory),
          name: String(c.dsTitle)
        }
        this.allCategories.push(category)
      });
    });
  }

  saveChanges(form: any) {
    this.itemService.apiItemPostPostForm(form.cdStore, form.categoria, form.nombre, form.descripcion, undefined, form.imagen._files[0], form.precioP?.value, form.precioM,
      form.precioG?.value, form.orden, undefined, form.textP, form.textM, form.textG, undefined, form.estado, form.banner).subscribe(response => {
        this.router.navigate(['product-management']);
        this.snackBar.openSnackBar('Los cambios se guardaron correctamente', 'Aceptar')
      },err => {
        this.snackBar.openSnackBar(err.error.error, 'Aceptar')
      })
  }

}

interface CategoryOption {
  id: number;
  name: string;
}
